//Node Modules
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

//My Components

//3rd Party Components

//State

//Config

//Helpers

//Other

const GridItemLink = ({ linkTo, label, icon }) => {
	//Hooks
	const { t } = useTranslation();

	return (
		<div className="gridItem-link">
			<Link to={linkTo} className="flexVert gapCol-small aItems-center">
				{icon && <i className={icon} />}
				{label && <span>{label}</span>}
			</Link>
		</div>
	);
};

export default GridItemLink;
